import React from 'react';
import { useTranslation } from 'react-i18next';
import { ImageWithPlaceholder } from '@wbk/ui';
import { ContentfulRichText } from '@wbk/contentful';
import {
  type ContentfulRichText as ContentfulRichTextType,
  type WebSection,
} from '@wbk/contentful/api';
import HeroTitle from '@/components/ui/HeroTitle';
import ReadMoreDialog from './components/DescriptionDialog';

type Props = {
  section?: WebSection;
};

const HeroSection = ({ section }: Props) => {
  const { t } = useTranslation('common');
  const [isReadMoreOpen, setIsReadMoreOpen] = React.useState(false);

  return (
    <>
      <div className='relative h-[95dvh]'>
        <div className='absolute inset-0'>
          <div className='pointer-events-none absolute inset-0 bg-gradient-to-b from-transparent via-black/90 to-black/80 mix-blend-multiply' />
          <ImageWithPlaceholder
            alt='explore hero'
            className='h-full w-full object-cover'
            src={section?.sectionBackground?.url}
          />
        </div>
        <div className='container-padding container h-full w-full'>
          <div className='container relative flex h-full max-h-[80%] w-full flex-col gap-4'>
            <div className='mt-auto flex h-full w-full flex-col items-center justify-end gap-6 sm:gap-6'>
              <div className='space-y-6 lg:space-y-10 rtl:space-y-4'>
                {section?.title && <HeroTitle className='uppercase' title={section?.title} />}
              </div>

              <div className='flex max-w-2xl flex-col justify-between gap-4 text-center text-[#A1A1AA]'>
                <div className='line-clamp-3'>
                  {section?.collapsableDescription && (
                    <ContentfulRichText description={section?.collapsableDescription} />
                  )}
                </div>
                <button
                  className='text-primary text-body-S underline'
                  onClick={() => setIsReadMoreOpen(true)}
                >
                  {t('sponsor_form.buttons.see_more')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ReadMoreDialog
        title={section?.title as string}
        description={section?.collapsableDescription as ContentfulRichTextType}
        isOpen={isReadMoreOpen}
        onClose={() => setIsReadMoreOpen(false)}
      />
    </>
  );
};

export default HeroSection;
